/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, date, DateFormat, entity, enumeration } from '@gh/core-data';

import { SalesFolderStatus } from '../leads';
import { ScheduleType } from '../schedule-templates';
import {
  CMDatesFilter,
  CMJobListFilterDto,
  ContractType, DatesFilter,
  JobBaseDesignListItemDto,
  JobBasicInfoDto,
  JobDppDetailsDto,
  JobListFilterDto,
  JobListItemDto,
  JobQuickCreateRequestDto,
  JobRedoDto,
  JobStatus,
  JobBillingDto,
  JobBillingWorksheetItem, JobBillingWorksheetExportDto,
} from './job.dto';

export const JobListItemMapper = entity<JobListItemDto>({
  contractTypeValue: enumeration(ContractType),
  statusValue:       enumeration(JobStatus),
  specProducedDate:  date(DateFormat.DateTime),
  finalizedDate:     date(DateFormat.DateTime),
  saleDateReported:  date(DateFormat.Date),
  slabDateReported:  date(DateFormat.Date),
});

export const JobCMListFilterMapper = entity<CMJobListFilterDto>({
  scheduleNotExist: enumeration(ScheduleType),
  dateType:         enumeration(CMDatesFilter),
});

export const JobListFilterMapper = entity<JobListFilterDto>({
  scheduleNotExist: enumeration(ScheduleType),
  dateType:         enumeration(DatesFilter),
});

export const JobBaseDesignListItemMapper = entity<JobBaseDesignListItemDto>({});

export const JobQuickDetailsMapper = entity<JobQuickCreateRequestDto>({
  createdLocal: date(DateFormat.DateTime),
});

export const JobDppDetailsMapper = entity<JobDppDetailsDto>({
  salesFolderStatus:    enumeration(SalesFolderStatus),
  salesFolderAddedDate: date(DateFormat.Date),
  saleDate:             date(DateFormat.Date),
  depositDate:          date(DateFormat.Date),
  notProceedingDate:    date(DateFormat.Date),
});

export const JobRedoDtoMapper = entity<JobRedoDto>({});

export const JobBasicInfoMapper = entity<JobBasicInfoDto>({});

export const JobBillingMapper = entity<JobBillingDto>({
  saleDate: date(DateFormat.Date),
  officeLastPaymentDate: date(DateFormat.Date),
  masterLastPaymentDate: date(DateFormat.Date),
  reportedSaleDate: date(DateFormat.Date),
  slabDate: date(DateFormat.Date),
  reportedSlabDate: date(DateFormat.Date),
});

export const JobBillingWorksheetFilterMapper = entity<any>({
  dateFrom: date(DateFormat.Date),
  dateType: enumeration(CMDatesFilter),
  dateTo: date(DateFormat.Date),
});

export const JobBillingWorksheetMapper = entity<JobBillingWorksheetItem>({
  officeLastPaymentDate: date(DateFormat.Date),
  officePaymentDate: date(DateFormat.Date),
  masterLastPaymentDate: date(DateFormat.Date),
  masterPaymentDate: date(DateFormat.Date),
});

export const JobBillingWorksheetExportMapper = entity<JobBillingWorksheetExportDto>(
  {
    jobList: arrayOf(JobBillingWorksheetMapper),
  });
